<template>
  <v-row no-gutters justify="space-between">
    <v-col cols="12">
      <h5 class="-font">{{ text }}</h5>
    </v-col>
    <v-col class="mt-4">
      <div class="d-flex flex-row align-center flex-wrap" style="gap: 15px;">
        <!-- Opções principais -->
        <v-checkbox
          multiple
          v-for="(option, i) in options"
          :key="i"
          class="mt-0 pt-0 secondary-font font-weight-bold"
          v-model="model.value"
          :label="option"
          :value="option"
        ></v-checkbox>
      </div>
      
      <!-- Opções condicionais -->
      <div v-if="conditionalOptions && shouldShowConditionalOptions" class="mt-2">
        <div class="d-flex flex-row align-center flex-wrap" style="gap: 15px; margin-left: 20px;">
          <v-checkbox
            multiple
            v-for="(conditionalOption, i) in conditionalOptions[selectedMainOption]"
            :key="`conditional-${i}`"
            class="mt-0 pt-0 secondary-font font-weight-bold"
            v-model="model.value"
            :label="conditionalOption"
            :value="conditionalOption"
          ></v-checkbox>
        </div>
      </div>
    </v-col>
    <v-col cols="12" v-if="justify">
      <v-text-field
        v-model="model.text"
        :label="textJustify || 'Comentrários'"
        class="custom-textfield "
        solo
        flat
        dense
        hide-details
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: {
      type: null,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    justify: {
      type: Boolean,
      default: false
    },
    textJustify: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    conditionalOptions: {
      type: Object,
      default: null
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    selectedMainOption() {
      if (this.model.value && Array.isArray(this.model.value)) {
        for (const option of this.options) {
          if (this.model.value.includes(option)) {
            return option
          }
        }
      }
      return null
    },
    shouldShowConditionalOptions() {
      return this.selectedMainOption && 
             this.conditionalOptions && 
             this.conditionalOptions[this.selectedMainOption]
    }
  }
}
</script>

<style scoped>
.v-input >>> label {
  font-size: 14px !important;
}
</style>
